import styled from 'styled-components'
import { Content } from 'modals/dialog/s'

export const EmojiContent = styled(Content)`
    user-select: none;
`